import { Injectable } from '@angular/core';

import { Farm } from '../model/production/unit/farm';
import { Field } from '../model/production/unit/field';
//import { RepositoryProvider } from '../providers/repository/repository';
//import { DataStore } from './data-store';
//import { PolygonUtil } from './polygon-util';
import { ILatLng } from '@ionic-native/google-maps';
import { MapProvider } from '../providers/map';

@Injectable()
export class FieldUtil {

    //private _polygonUtil = new PolygonUtil();

    constructor(/*private _repository: RepositoryProvider*/) {
    }

    public async getFieldByCurrentLocation(map: MapProvider, currentPosition?:ILatLng)/*: Promise<Field> */{

     /*   if (currentPosition == undefined) {
            currentPosition = <ILatLng>await map.getCurrentPosition();
            if (!currentPosition) {
                return new Promise<Field>(resolve => resolve(null));
            }    
        }

        let farms = await this._repository.findAll(DataStore.FARM);
        let allFields: Field[] = [];

        farms.forEach((result: Farm) => {
            let farm = new Farm(result);
            const fields = farm.getFields();
            if (fields.length) {
                allFields = allFields.concat(fields);
            }
        })

        let polygons = allFields.map(field => field.polygon);

        let insideList = this._polygonUtil.pointInPolygons(currentPosition, polygons);
        if (insideList.length)
            return new Promise<Field>(resolve => {
                resolve(allFields[insideList[0]]);
            });
        else
            return new Promise<Field>(resolve => resolve(null)); */
    }
}